import { render, staticRenderFns } from "./HubProfile.vue?vue&type=template&id=162c4a40&"
import script from "./HubProfile.vue?vue&type=script&lang=js&"
export * from "./HubProfile.vue?vue&type=script&lang=js&"
import style0 from "./HubProfile.vue?vue&type=style&index=0&id=162c4a40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports